import React, { useMemo, useState } from "react";
import RRProcedimientos from '../renderRows/RRProcedimientos.js';
import AddItm from '../addItm/AddItm.js';
import SearchInput from '../searchInput/SearchInput.js';
import ProcedimientoInfo from "../procedimientoInfo/ProcedimientoInfo.js";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";

import { useNavigate } from "react-router-dom";

import './ProcedimientosList.css';
import { checkDoubleQuotes, removeDoubleQuotesFromFilter } from "../../utils/funciones.js";
import normalizeText from "../../utils/normalizeText.js";

const ProcedimientosList = ({procedimientos, setProcToModify, setShowABM, setTitle, eliminarProcedimiento, actualizarProcedimientoList, getProcedimientoByID}) => {

    const [filter,setFilter] = useState('');
    const [showInfo,setShowInfo] = useState(undefined);

    const navigate = useNavigate();

    const handleClickAdd = () =>{
        setTitle('Nuevo Procedimiento');
        setShowABM(false);
    }

    const handleSearchInput = (e) => {
        setFilter(e);
    }

    const handleLookInfo = (proc) => {
        setShowInfo(proc);
    }

    let procedimientosFiltered = useMemo(()=> procedimientos?.filter(p => {
            return filter != '' ? 
                checkDoubleQuotes(filter) ?
                    normalizeText(p.codProc) == removeDoubleQuotesFromFilter(filter) || normalizeText(p.name) == removeDoubleQuotesFromFilter(filter)
                :
                    normalizeText(p.codProc).includes(normalizeText(filter)) || normalizeText(p.name).includes(normalizeText(filter))
            : true
        }), [procedimientos, filter]);

    if(procedimientos == null) return <h3 className="warningStatusMsg">Cargando <span>.</span><span>.</span><span>.</span></h3>
    
    else return <div className="procedimientosList"> 
        <AddItm titulo={'Procedimiento'} anadiritm={handleClickAdd}/>
        <SearchInput buscar={handleSearchInput} filter={filter}/>
        {procedimientosFiltered.length == 0 ? <h3 className="warningStatusMsg">No hay procedimientos cargado</h3> : procedimientosFiltered.map((p, i) => <RRProcedimientos key={p._id} procedimiento={p} i={i} FontAwesomeIcon={FontAwesomeIcon} setProcToModify={setProcToModify} setShowABM={setShowABM} eliminarProcedimiento={eliminarProcedimiento} actualizarProcedimientoList={actualizarProcedimientoList} showInfo={showInfo} handleLookInfo={handleLookInfo} getProcedimientoByID={getProcedimientoByID}/>)}
        {showInfo != undefined && <ProcedimientoInfo procedimiento={showInfo} handleLookInfo={handleLookInfo}/>}
    </div>

}

export default ProcedimientosList;